import { takeEvery } from 'redux-saga/effects'
import { userLogin } from './slice'

function* login() {}

function* labSaga() {
  yield takeEvery(userLogin, login)
}

export default labSaga
